"use strict";

exports.__esModule = true;
// istanbul ignore next

function _interopRequire(obj) { return obj && obj.__esModule ? obj["default"] : obj; }

require("../../polyfill");

var _node = require("./node");

exports["default"] = _interopRequire(_node);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/lib/api/register/node-polyfill.js
 ** module id = 530
 ** module chunks = 0
 **/